import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-card-placeholder',
  standalone: false,
  template: `<div class="card-skeleton-body tiles-stacked"  *ngIf="content">
    <div class="text-left">
      @if(undoLinkActive){
        <button
          type="button"
          size="small"
          [arrowLeft]="true"
          (click)="undoDelete()"
          [ariaLabel]="ariaLabel | friendlyname: 'ada'"
          cdsButton="tertiary"
          class="undoBtn">
          {{content.undoLabel}}
        </button>
      }
    </div>
    <div class="text-center">
      <h2 class="card_title ph cc-title" [innerHTML]="content.addCardTitle" [id]="'selected-card-'+cardIndex"></h2>
      <div class="btn-add-card-wrapper">
        <a class="btn-add-card" role="button" [mktRouterLink]="content.addCardLink" [attr.aria-label]="content.addCardBtnLabel">
          <span aria-hidden="true" class="btn-link btn-icon large bold" [innerHtml]="content.addCardBtnLabel"></span>
        </a>
      </div>
    </div>
  </div>`,
  styles: [
    `
    .card-skeleton-body h2.card_title {
      font-size: 1.3rem!important;
      color: #333333;
      font-weight: 400;
      letter-spacing: 0;
      text-align: center;
      line-height: 27px;
      cursor: pointer;
      margin-top: 0px;
    }
    .card-skeleton-body .text-left {
      min-height: 20px;
    }    
    .undoBtn {
      padding: 0 !important;
      margin: 0 !important;
    }      
    .card-skeleton-body .btn-add-card-wrapper {
      margin-top: 50px;
    }
    ::ng-deep.card-skeleton-body .btn-add-card {
      padding: 30px;
      border: 1px solid #333;
      border-radius: 5px;
      color:#333;
      font-size: 1.3125rem;
      font-weight: 700;
    }
    ::ng-deep.card-skeleton-body .btn-link.btn-icon{
      color:#333 !important;
      text-decoration: none;
    }
    ::ng-deep.card-skeleton-body .btn-link.btn-icon::before {
      filter: grayscale(1) brightness(0.3);
    }

    .card-skeleton-body .cds-button-sm.cds-button-chevron-left::before{
      width: 13px;
    }
    @media only screen and (max-width: 900px){
      .card-skeleton-body h2.card_title {
        font-size: 1rem !important;
      }
      ::ng-deep.card-skeleton-body .btn-add-card {
        padding: 20px;
      }
      .card-skeleton-body .btn-add-card-wrapper {
        margin-top:32px;
      }
      .card-skeleton-body .btn-link{
        font-size:1rem;
      }
    }
    `,
  ],
})
export class CardPlaceholderComponent implements OnInit {

  @Input() undoLinkActive: any;
  @Input() cardIndex: string;
  @Input() deletedCard: any;
  @Input() content: any;
  @Input() stickyId: string = '';
  @Output() undo = new EventEmitter<string>();
  public ariaLabel: string = '';

  ngOnInit() {
    if (!!this.deletedCard) {
      this.ariaLabel = `Undo the removal of ${this.deletedCard?.cardName}`;
    } else {
      this.ariaLabel = `Undo`;
    }
  }

  undoDelete() {
    this.undo.emit();
  }
}
